<template>
    <div class="">
        <b-navbar toggleable="lg" class="scrolled" >

            <b-navbar-toggle target="nav_menu"></b-navbar-toggle>

            <b-collapse id="nav_menu" is-nav>

                <!-- Menu -->
                <b-navbar-nav class="col-11">
                    <b-nav-item :to="{name: 'reserva'}" exact>
                        <b-button variant="outline-primary">RESERVA</b-button>
                    </b-nav-item>
                    <b-nav-item :to="{name: 'hoteles'}" exact>
                        <b-button variant="outline-primary">HOTELES</b-button>
                    </b-nav-item>
                    <!-- <b-nav-item :to="{name: 'folletos'}" exact>
                        <b-button variant="outline-primary">FOLLETOS</b-button>
                    </b-nav-item> -->
                    <b-nav-item :to="{name: 'informacion'}" exact>
                        <b-button variant="outline-primary">INFORMACIÓN</b-button>
                    </b-nav-item>
                    <b-nav-item :to="{name: 'contacto'}" exact>
                        <b-button variant="outline-primary">CONTACTO</b-button>
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Acceso -->
                <b-navbar-nav class="col-1" >
                    <b-dropdown right variant="primary-outline" size="sm">
                        <template slot="button-content">
                            <b-avatar v-if="logueado" variant="light"></b-avatar>

                        </template>
                        <div  v-if="!logueado">
                            <!-- <b-dropdown-item :to="{name: 'login'}">LOGIN</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'registro'}">REGISTRO</b-dropdown-item> -->
                            <b-dropdown-item @click="login">ACCESO</b-dropdown-item>
                            <b-dropdown-item @click="registro">REGISTRARSE</b-dropdown-item>
                        </div>
                        <div v-else>
                            <b-dropdown-item :to="{name: 'info-personal'}" variant="success">
                                <b>{{usuario}}</b><br>
                                <small>
                                <ul class="menu-opcion">
                                    <li>Datos Cuenta</li>
                                    <!-- <li>Reservas</li> -->
                                    <li>Notificaciones</li>
                                </ul>
                                </small>
                            </b-dropdown-item>

                            <b-dropdown-divider/>
                            <b-dropdown-item :to="{name: 'reservas'}" variant="dark" class="bg-light">RESERVAS</b-dropdown-item>
                            <b-dropdown-divider/>
                            <b-dropdown-item @click="desconectar" variant="dark" class="bg-light">Cerrar Sesión</b-dropdown-item>
                        </div>
                        <!-- Opciones para Admin -->
                        <div v-if="usuario=='abakan'||usuario=='cemo'">
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item :to="{name: 'contacto'}">Contacto</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'condiciones-generales'}">Condiciones Generales</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'politica'}">Politica de Privacidad</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'avisolegal'}">Aviso Legal</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'cookies'}">Cookies</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'informacion'}">Información</b-dropdown-item>
                            <!-- <b-dropdown-item
                                @click="openAlerta" href="#"
                            >   INFORMACION
                            </b-dropdown-item> -->

                            <div  v-if="logueado">
                                <b-dropdown-divider></b-dropdown-divider>
                                <!-- <b-dropdown-item :to="{name: 'reservas'}">RESERVAS</b-dropdown-item> -->
                                <!-- <b-dropdown-item :to="{name: 'reserva'}">Reserva</b-dropdown-item> -->
                                <!-- <b-dropdown-item :to="{name: 'pago-tarjeta'}">Pago TARJETA</b-dropdown-item> -->
                            </div>
                            <!-- <span class="ml-2 text-info center small"></span> -->
                        </div>
                        <div class="w-100 text-center">
                            <span class="text-primary small">version {{ version }}</span>
                        </div>
                    </b-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <header class="header">
            <div class="container-fluid text-center py-0">
                <h1 class="h3 text-gray mb-0">{{ aplica.titulo }} {{ aplica.programa }}</h1>
                <h1 class="h6 text-primary mb-0">{{ aplica.subtitulo }} - {{ aplica.subtitulo2 }}</h1>
                <!-- activo, admon -->
                <h4 v-if="!aplica.activo" class="text-danger mb-0">SISTEMA CERRADO</h4>
                <h4 v-if="aplica.admon" class="text-danger text-bold mb-0">MODO ADMINISTRACION</h4>
            </div>
        </header>

    </div>
</template>

<script>

//import { mapState, mapMutations, mapActions } from 'vuex';
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'AppMenu',
    components: {

    },
    data: () => ({
        //titulo: 'PAGINA WEB',
    }),

    computed: {
        ...mapState(['aplica','auth']),

        logueado() {
            return this.auth.logueado;
        },
        usuario() {
            return this.auth.user.name;
        },
        version() {
            return process.env.VUE_APP_VERSION;
        },

    },
    methods: {
        ...mapMutations(['login_back','login_off','modal']),

        login() {
            //this.$root.$emit('modal','modal_login');
            this.$bvModal.show("modal_login");
        },
        registro() {
            this.$bvModal.show("modal_registro");
        },

        desconectar() {
            //this.$store.commit('modal',{tit:"Desconectar",msg:"Se ha desconectado de la Sesion"});
            //this.$store.commit('login_off');
            this.modal({tit:"Desconectar",msg:"Se ha desconectado de la Sesion",time:2000});
            this.login_off();
            //redireccionamos a raiz (home)
            this.$router.push('/');
        },
        openAlerta() {

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete everything.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ACEPTAR',
                cancelTitle: 'CANCELAR',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                //this.boxTwo = value
                console.log(value);
            })
            .catch(error => {
                // An error occurred
                console.log(error)
            })
        }
    },

}
</script>